import { Select, SelectItem } from "@heroui/react";

const HeadingSelect = ({ headings, selectedKeys, onSelectionChange }) => (
  <Select
    classNames={{
      label: "group-data-[filled=true]:-translate-y-5 text-black text-base",
      popoverContent: "w-80",
      trigger: "min-h-16 bg-transparent shadow-none w-40",
      listboxWrapper: "bg-transparent w-80",
    }}
    items={headings}
    label="Sektionen"
    selectionMode="multiple"
    selectedKeys={selectedKeys}
    onSelectionChange={onSelectionChange}
  >
    {(heading) => (
      <SelectItem key={heading.key}>{heading.label}</SelectItem>
    )}
  </Select>
);

export default HeadingSelect;
